import { render, staticRenderFns } from "./GerenciadorDeAcessos.vue?vue&type=template&id=2a8e559e"
import script from "./GerenciadorDeAcessos.vue?vue&type=script&lang=js"
export * from "./GerenciadorDeAcessos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports